/**
 * FAQ 관련 API
 * OpenAPI Generator로 생성된 타입을 사용하며, 기존 Axios 인스턴스와 통합
 */
export class CommunityFAQService {
    constructor(axiosInstance) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axiosInstance;
    }
    /**
     * 활성 FAQ 조회
     * 활성화된 FAQ를 페이지네이션과 검색 필터를 적용하여 조회합니다. 제목과 카테고리로 필터링할 수 있으며, 최신순으로 정렬됩니다.
     * @param searchRequest - FAQ 검색 조건
     * @param pageable - 페이지네이션 및 정렬 정보
     * @returns 활성 FAQ 조회 결과
     */
    getActiveFaqs(searchRequest, pageable) {
        return this.axios.get(`/co/v1/support/faqs`, {
            params: {
                ...searchRequest,
                ...pageable,
            },
        });
    }
    /**
     * FAQ 상세 정보를 조회합니다.
     * FAQ ID를 통해 상세 정보를 조회합니다. 조회 시 조회수가 증가합니다.
     * @param id - 조회할 FAQ의 ID
     * @returns FAQ 상세 정보를 조회합니다. 결과
     */
    getFaqDetail(id) {
        return this.axios.get(`/co/v1/support/faqs/${id}`);
    }
}
//# sourceMappingURL=faq.service.js.map